const splitExtension = (filename: string) => {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1 || lastDotIndex === 0 || lastDotIndex === filename.length - 1) return [filename, ''];
  else return [filename.substring(0, lastDotIndex), filename.substring(lastDotIndex + 1)];
};

export default splitExtension;
